import { IssueMarkType, IssueStatusType } from '@kcftech/prometheus-client';
import { MissionControlCategoryIssueMarkTypes } from '@kcftech/prometheus-constants';
import { filterMapToSet } from 'utils/array';
import { type QueueIssueItem } from './queueTypes';

// TODO: replace with the generated rules from `@kcftech/prometheus-constants` once
// published: the resolvable-by sets from the backend's `IssueMarkEnumRules`, and the
// active statuses from `AssemblyContextQuery.ActiveIssueStatuses`.

/**
 * Statuses whose Issues Mission Control lists. An Issue in any other status drops out of
 * every section, whatever its Issue Marks.
 */
export const ACTIVE_ISSUE_STATUS_TYPES: ReadonlySet<IssueStatusType> = new Set([
    IssueStatusType.New,
    IssueStatusType.Open,
    IssueStatusType.Draft,
]);

/** Issue Mark types that publishing a Draft Issue (Draft -> New) resolves. */
export const PUBLISH_RESOLVED_MARK_TYPES: ReadonlySet<IssueMarkType> = new Set([
    IssueMarkType.GfdDraft,
    IssueMarkType.CriticalAlarmDraftIssue,
]);

/**
 * The types of an Issue's unresolved Needs Attention Issue Marks. Needs Attention
 * reasons carry only the Issue's id, so this is how their triggering marks are
 * recovered.
 */
export function getNeedsAttentionMarkTypes(item: QueueIssueItem): Set<IssueMarkType> {
    return filterMapToSet(
        item.IssueMarks,
        (m) =>
            !m.ResolvedTime &&
            MissionControlCategoryIssueMarkTypes.NeedsAttention.has(m.Type),
        (m) => m.Type,
    );
}
